module.exports = require("@swa-ui/itinerary");